<template>
    <div class="results-row">
        "{{result.key}}" : {{result.value}}
    </div>
</template>

<script>

  import Result from './Result';

  export default {
    name: 'Match',
    props: {
      result: Object,
      searchText: String,
      searchType: String
    },
    data() {
      return {
      }
    },
    components: {
      Result
    },
    methods: {
    },
    computed: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .results-row {
    text-align:center;
    margin: 20px;
    padding:20px;
  }

</style>
